module.exports = {
	"fr": {
		"ui.about.title.overview": "De la donnée humanitaire à jour",
		"ui.about.subhead": "Télécharger la dernière mise à jour de la donnée OSM pour l'utiliser dans des analyses SIG ou dans des appareils GPS et des smartphones. ",
		"ui.about.overview": "Ce service vous permet de créer des exports personnalisés de la donnée OpenStreetMap (OSM) sur des territoires humanitaires. Vous pouvez préciser une aire d'intérêt et une liste d'attributs OSM. Les formats de fichiers disponibles sont les suivants :  ESRI shapefile, Garmin IMG, Google KMZ, OSM PBF et SQlite SQL. La donnée OSM disponible depuis HOT Export est mise à jour chaque minute. ",
		"ui.about.title.getting_started": "Comment débuter",
		"ui.about.getting_started": "",
		"ui.exports": "Exports",
		"ui.exports.title": "Exports",
		"ui.help": "Aide",
		"ui.login": "Authentification",
		"ui.about.license": "",
		"ui.about.license.odbl": "Licence ODbL 1.0",
		"ui.aoi_toolbar.tools": "",
		"ui.draw.box": "",
		"ui.draw.draw": "",
		"ui.draw.import": "",
		"ui.draw.current_view": "",
		"ui.authorized.thank_you": "",
		"configuration.description.label": "Description",
		"ui.configuration.description.label": "Description",
		"export.description.label": "Description",
		"exports.description.label": "Description",
		"configuration.description.placeholder": "",
		"configuration.feature_selection.label": "",
		"configuration.name.label": "Nom",
		"ui.configuration.name.label": "Nom",
		"export.name.label": "Nom",
		"exports.name.label": "Nom",
		"configuration.name.placeholder": "",
		"configuration.public.description": "",
		"ui.configuration.update": "",
		"ui.configuration.create": "",
		"ui.configuration.delete": "",
		"ui.configuration.title": "Configurations",
		"configuration.title": "Configurations",
		"ui.configurations": "Configurations",
		"ui.configuration.tables.label": "",
		"ui.configuration.owner.label": "Propriétaire ",
		"exports.owner.label": "Propriétaire ",
		"export.project.label": "Projet",
		"exports.project.label": "Projet",
		"export.area.label": "",
		"export.area": "",
		"export.created_at.label": "",
		"export.created_by.label": "",
		"export.published.label": "Publié",
		"yes": "",
		"no": "",
		"export.export_formats.label": "",
		"export.osma.label": "",
		"ui.view_this_area": "",
		"ui.exports.status": "",
		"ui.exports.started": "",
		"ui.exports.finished": "",
		"ui.exports.duration": "",
		"ui.exports.features": "Objets",
		"ui.exports.rerun_export": "",
		"ui.exports.clone_export": "Dupliquer l'export ",
		"ui.exports.feature_selection.title": "Sélection des objets",
		"export.feature_selection.label": "Sélection des objets",
		"ui.close": "Fermé",
		"export.errors.the_geom.too_large": "",
		"export.buffer_aoi.description": "",
		"export.name.placeholder": "",
		"export.project.placeholder": "",
		"export.published.description": "",
		"export.tag_tree_search.placeholder": "",
		"nav.next": "",
		"export.feature_selection.load_from_josm_preset": "",
		"ui.clear": "",
		"configuration.load_yaml": "",
		"ui.exports.tag_tree": "",
		"ui.exports.stored_configuration": "",
		"ui.exports.create_export": "Créer l'export",
		"ui.exports.describe_export": "Description de l'Export",
		"ui.exports.choose_formats": "",
		"ui.exports.select_features": "Sélectionnez les fonctionnalités",
		"ui.exports.summary": "",
		"ui.overpass_last_updated": "",
		"ui.show_on_map": "",
		"exports.created.label": "Créé",
		"ui.settings": "",
		"ui.never": "",
		"exports.schedule.6hrs": "",
		"exports.schedule.daily": "",
		"exports.schedule.weekly": "",
		"exports.schedule.monthly": "",
		"ui.unknown": "",
		"ui.untitled": "",
		"runs.last_run.label": "",
		"runs.next_run.label": "",
		"runs.schedule.label": "",
		"ui.private": "Privé",
		"ui.search.only_mine": "",
		"ui.search.placeholder": "",
		"ui.search": "Rechercher",
		"ui.login_to_osm": "Authentification à OpenStreetMap",
		"ui.hot.title": "Humanitarian OpenStreetMap Team (Équipe humanitaire OpenStreetMap)",
		"ui.toggle_navigation": "",
		"ui.osm_export_tool.title": "Service HOT Export",
		"ui.create": "Création",
		"ui.hdx": "",
		"ui.about": "À propos",
		"ui.log_out": "Déconnexion",
		"ui.log_in": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales/fr.json
// module id = 1493
// module chunks = 1